import React, { useState } from 'react'
import SidebarTemplatesAccordian from 'components/Sidebars/SidebarTemplatesAccordian'
import Layout from 'components/Layout'
import ScreenShell from 'components/ScreenShell/ScreenShell'
import Templates from './components/Templates/Templates'

const Templates_Index = () => {
	const [openPopup, setOpenPopup] = useState(false)

	return (
		<ScreenShell>
			<Layout>
				<Layout.Page>
					<Layout.Sidebar>
						<Layout.SidebarUserCard />

						<SidebarTemplatesAccordian />
					</Layout.Sidebar>
					<Layout.Body>
						<Layout.PageHeader>
							<h2>Templates tsx</h2>
						</Layout.PageHeader>
						<Templates openPopup={openPopup} setOpenPopup={setOpenPopup} />
					</Layout.Body>
				</Layout.Page>
			</Layout>
		</ScreenShell>
	)
}

export default Templates_Index
